// 資料匯出匯入formatter
import { Component, Injector, OnInit, inject, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { JkBatchComponent, } from 'jk-advcom';
import { ConfigError, format, FormatOptionsWithLanguage } from 'sql-formatter';
import { idNameItem, JkBaseOption, MaterialModule, TitlebarComponent } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';

class Utyjb01Option extends JkBaseOption {
  // ###
  input: string = '';
  output: string = '';
}


@Component({
  standalone: true,
  selector: 'app-utyjb01',
  templateUrl: './utyjb01.component.html',
  styleUrls: ['./utyjb01.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MaterialModule, JackBaseComponentModule,
    // JkgridwinComponent
  ],
})
export class Utyjb01Component extends JkBatchComponent implements OnInit {
  override _programId = 'utyjb01'; // ###
  readonly titlebar = viewChild.required<TitlebarComponent>('titlebar');
  filterOpt: Utyjb01Option = new Utyjb01Option(this.programId); //###
  orderList: idNameItem[] = [];
  hostList: idNameItem[] = [];
  constructor() {
    super();
    // jkApp.appPages.locale
    this.setFormOpt2(); //###
    //this.qryMaster = new StktmQuoteService();
    let idObj = { id: 'http://localhost:9086', name: '本機' };
    this.hostList.push(idObj);
    idObj = { id: 'http://jk-ubun:9086', name: '虛擬機jk-ubun' };
    this.hostList.push(idObj);
    this.logMessage = '無錯誤訊息';
  }

  override async ngOnInit() {
    super.ngOnInit();
  }
  override async ngAfterViewInit() {
    super.ngAfterViewInit();
    //this.masterGridSet.init(this.masterGrid, this.qryMaster);
    //this.detailGridSet.init(this.detailGrid, this.qryDetail as JkEntity);
    this.titlebar().onUser1Click = this.doRefresh;
    this.titlebar().user1Text = '重新顯示';
    this.titlebar().onUser2Click = this.doSQL;
    this.titlebar().user2Text = '執行SQL';
    this.titlebar().onUser3Click = this.doCopy2ClipBoard;
    this.titlebar().user3Text = '複製到剪貼簿';
    this.titlebar().onUser4Click = this.doSqlFormatter;
    this.titlebar().user4Text = 'SQL格式化';

    try {
    } catch (error) { }
    this.checkAllInit(this); // 這行要放在 ngAfterViewInit 最後  ###
  }
  ngOnExit() { }
  /*override onWindowResize() {
    super.onWindowResize();
    // ###
    super.onWindowResize();
    this.filterOpt.setColCount(window.innerWidth);
  }*/
  // ### [以上是必要的]================================
  override async doRefresh(): Promise<void> {
    super.doRefresh();
    return;
  }
  doSQL() { }
  doCopy2ClipBoard() { }
  doSqlFormatter() {
    try {
      let config: FormatOptionsWithLanguage = {
        language: 'sql', //language.options[language.selectedIndex].value,
        tabWidth: 2,
        useTabs: false, // useTabs.checked,
        keywordCase: 'upper', // keywordCase.options[keywordCase.selectedIndex].value,
        indentStyle: 'tabularLeft', // indentStyle.options[indentStyle.selectedIndex].value,
        //commaPosition: 'after', // commaPosition.options[commaPosition.selectedIndex].value,
        logicalOperatorNewline: 'before', //           logicalOperatorNewline.options[logicalOperatorNewline.selectedIndex].value,
        // tabulateAlias: false, // tabulateAlias.checked,
        expressionWidth: 80, // 0~200 expressionWidth.value,
        // lineBetweenQueries: 1, // lineBetweenQueries.value,
        denseOperators: true, // denseOperators.checked,
        newlineBeforeSemicolon: false, // newlineBeforeSemicolon.checked,
      };
      this.filterOpt.output = format(this.filterOpt.input, config);
      // showOutput(sqlFormatter.format(input.value, config));
      //this.pageOpt.input = output;
      console.log(this.filterOpt.output);
    } catch (e: any) {
      if (e instanceof ConfigError) {
        this.logMessage = `<h2>Configuration error</h2><p>${e.message}</p>`;
      } else {
        this.logMessage = `
<h2>An Unexpected Error Occurred</h2>
<p><strong>${e.message}</strong></p>
<p>
  Please report this at
  <a href="https://github.com/sql-formatter-org/sql-formatter/issues">Github issues page.<a>
</p>
<p>Stack Trace:</p>
<pre>${e.stack.toString()}</pre>
`;
      }
    }
  }
}
